
import Dropzone from 'react-dropzone';
import Cloud from '../Assets/images/cloud.svg'
import { Close, DeleteOutline } from '@mui/icons-material';
const ImageUploader = ({images, setImages, variant = 'default', minimumText = 'Upload minimum of 4 images', multiple = true}) => {
  

  const handleDrop = (acceptedFiles) => {
    const maxSize = 1024 * 1024; // 1MB
    const updatedImages = acceptedFiles.filter((file) => {
        return file.size <= maxSize && file.type.startsWith('image/');
      });
      setImages((prevImages) => multiple ? [...prevImages, ...updatedImages] : updatedImages.slice(0, 1));
  };

  const handleRemove = (index) => {
    const updatedImages = [...images];
    updatedImages.splice(index, 1);
    setImages(updatedImages);
  };

  // const handleSubmit = async () => {
  //   // Prepare form data
  //   const formData = new FormData();
  //   images.forEach((image) => {
  //     formData.append('images', image);
  //   });

  //   try {
  //     // Make API request
  //     const response = await axios.post('/api/upload', formData, {
  //       headers: {
  //         'Content-Type': 'multipart/form-data',
  //       },
  //     });

  //     // Handle response
  //     console.log(response.data); // Modify this to handle the response from the API

  //     // Clear uploaded images
  //     setImages([]);
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  if (variant === 'asset') {
    return (
      <div>
        <Dropzone onDrop={handleDrop} accept="image/*" multiple={multiple}>
          {({ getRootProps, getInputProps }) => (
            <div className="dropzone" {...getRootProps()}>
              <input className='border w-full' {...getInputProps()} accept="image/*" />
              <div className='border-2 border-primary-color rounded-lg px-4 py-8 text-center cursor-pointer bg-white'>
                <span className='inline-flex h-14 w-14 items-center justify-center rounded-md border border-gray-100 shadow-sm mb-5'>
                  <img src={Cloud} className='h-7 w-7' alt='Cloud'/>
                </span>
                <p className='text-sm md:text-base text-text'>
                  <span className='text-primary-color'>Click to upload</span> or drag and drop
                </p>
                <p className='text-sm md:text-base text-gray-400 mt-3'>SVG, PNG, JPG or GIF (max. 800x400px)</p>
              </div>
            </div>
          )}
        </Dropzone>
        {images.length > 0 && (
          <div className='mt-5'>
            <h4 className='mb-3 text-sm md:text-base font-medium text-text'>{minimumText}</h4>
            <div className='grid grid-cols-2 sm:grid-cols-4 gap-4'>
              {images.map((image, index) => (
                <div className='relative overflow-hidden rounded-2xl bg-[#F4F5F8] aspect-square' key={`${image.name}-${index}`}>
                  <img src={URL.createObjectURL(image)} className='h-full w-full object-cover' alt="uploaded" />
                  <button type='button' className='absolute top-3 right-3 flex h-7 w-7 items-center justify-center rounded-full bg-text text-white' onClick={() => handleRemove(index)}>
                    <Close fontSize='small'/>
                  </button>
                  {index === 0 && (
                    <div className='absolute bottom-0 left-0 right-0 bg-primary-color py-2 text-center text-sm font-bold text-white'>
                      Set as primary
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  }

  return (
    <div>
      <Dropzone onDrop={handleDrop} accept="image/*" multiple={multiple}>
        {({ getRootProps, getInputProps }) => (
          <div className="dropzone" {...getRootProps()}>
            <input className=' border w-full ' {...getInputProps()} accept="image/*"  />
            <p className=' border-dashed border-2  border-gray-200 rounded-lg p-3 py-6 '> <img src={Cloud} className=' inline-block' alt='Cloud'/> Drag and drop some files here.   or <span className=' p-3  bg-[#E6E6E7] cursor-pointer'>Tap here to choose a file</span> </p>
          </div>
        )}
      </Dropzone>
      {images.length > 0 && (
        <div>
          <h4 className=' my-3 text-[16px] font-bold'>Selected Images:</h4>
          <div className=' flex gap-3 mx-auto '>
          {images.map((image, index) => (
            <div className=' relative' key={index}>
              <img src={URL.createObjectURL(image)}  alt="uploaded" />
              <button type='button' className=' absolute top-0 right-0 text-primary-color' onClick={() => handleRemove(index)}><DeleteOutline/></button>
            </div>
          ))}
          </div>
         
        </div>
      )}
      {/* <button onClick={handleSubmit}>Upload Images</button> */}
    </div>
  );
};

export default ImageUploader;
